import React from "react";
import { Play, Pause, Volume2, VolumeX, Loader2 } from "lucide-react";
import { usePlayer } from "../context/PlayerContext";
import { Slider } from "./ui/slider";
import { STATION } from "../mock";

// Persistent bottom player shown once playback has started.
const MiniPlayer = () => {
  const { hasStarted, isPlaying, isLoading, togglePlay, volume, isMuted, setVolume, toggleMute, nowPlaying } = usePlayer();

  if (!hasStarted) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 px-3 pb-3 sm:px-5 sm:pb-5">
      <div className="mx-auto flex max-w-3xl items-center gap-4 rounded-2xl glass px-4 py-3">
        <button
          onClick={togglePlay}
          aria-label={isPlaying ? "Pauze" : "Afspelen"}
          className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#2E7DF7] to-[#1E6BE6] text-white shadow-lg shadow-blue-500/40 transition-transform hover:scale-105 active:scale-95"
        >
          {isLoading ? <Loader2 className="h-5 w-5 animate-spin" /> : isPlaying ? <Pause className="h-5 w-5" fill="currentColor" /> : <Play className="h-5 w-5 ml-0.5" fill="currentColor" />}
        </button>

        <div className="flex items-center gap-3 min-w-0">
          <div className="hidden h-10 w-10 shrink-0 overflow-hidden rounded-lg bg-gradient-to-br from-[#2E7DF7] to-[#1E6BE6] sm:block">
            {nowPlaying.artwork ? (
              <img
                key={nowPlaying.artwork}
                src={nowPlaying.artwork}
                alt={nowPlaying.title}
                className="h-full w-full object-cover"
                data-testid="mini-player-artwork"
                onError={(e) => { e.currentTarget.style.display = "none"; e.currentTarget.nextSibling.style.display = "block"; }}
              />
            ) : null}
            <img
              src={STATION.logoFull}
              alt=""
              className="h-full w-full object-contain p-2"
              style={{ display: nowPlaying.artwork ? "none" : "block" }}
            />
          </div>
          <div className="min-w-0">
            <div className="flex items-center gap-2">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-red-500" />
              </span>
              <span className="text-[11px] font-bold uppercase tracking-widest text-red-600">Live</span>
            </div>
            <p className="text-sm font-semibold text-slate-900">{nowPlaying.title}</p>
          </div>
        </div>

        <div className="ml-auto hidden items-center gap-2 sm:flex w-40">
          <button onClick={toggleMute} className="text-slate-500 hover:text-[#1E6BE6] transition-colors" aria-label="Dempen">
            {isMuted || volume === 0 ? <VolumeX className="h-5 w-5" /> : <Volume2 className="h-5 w-5" />}
          </button>
          <Slider value={[isMuted ? 0 : Math.round(volume * 100)]} max={100} step={1} onValueChange={(v) => setVolume(v[0] / 100)} className="vol-slider flex-1" aria-label="Volume" />
        </div>
      </div>
    </div>
  );
};

export default MiniPlayer;
